import angular from 'angular'

import phoneRequest from './services/request.service'
import phoneResource from './services/resource.service'
import phoneAsk from './services/ask.service'
import phone from './services/phone.service'
import myPhonesCreate from './directives/myPhonesCreate'
import myPhone from './directives/myPhone'
import myPhoneInfo from './directives/myPhoneInfo'
import myTelInput from './directives/inputs/myTelInput'

import phoneLabels from './resources/labels.resource'

const name = 'phone'
angular.module(name, [])
  .factory('phoneRequest', phoneRequest)
  .factory('phoneResource', phoneResource)
  .factory('phoneAsk', phoneAsk)
  .factory('$$phone', phone)
  .directive('myPhonesCreate', myPhonesCreate)
  .directive('myPhone', myPhone)
  .directive('myPhoneInfo', myPhoneInfo)
  .directive('myTelInput', myTelInput)
  .factory('phoneLabels', phoneLabels)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/phone/phone.module.js